import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=cb8e7bce&"
import script from "./DashboardManager.vue?vue&type=script&lang=js&"
export * from "./DashboardManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports